(() => {
  if (window.gtGiftChoiceDetailsReady) return;
  window.gtGiftChoiceDetailsReady = true;
  let timer, held = false, startX = 0, startY = 0, active = null, bubble = null;
  const linkOf = el => el instanceof Element ? el.closest('#CartDrawer .gt-gift-choice__link') : null;
  function ensureBubble() {
    if (bubble && bubble.isConnected) return bubble;
    bubble = document.createElement('div');
    bubble.className = 'gt-gift-choice-floating';
    bubble.setAttribute('role', 'tooltip');
    bubble.hidden = true;
    for (const tag of ['strong', 'span', 'span']) bubble.appendChild(document.createElement(tag));
    document.body.appendChild(bubble);
    return bubble;
  }
  function position(x, y) {
    if (!bubble || bubble.hidden) return;
    const rect = bubble.getBoundingClientRect(), pad = 12;
    let left = x + 14, top = y + 18;
    if (left + rect.width > window.innerWidth - pad) left = x - rect.width - 14;
    if (top + rect.height > window.innerHeight - pad) top = y - rect.height - 14;
    bubble.style.left = Math.max(pad, Math.min(left, window.innerWidth - rect.width - pad)) + 'px';
    bubble.style.top = Math.max(pad, Math.min(top, window.innerHeight - rect.height - pad)) + 'px';
  }
  function show(link, x, y) {
    active = link;
    const box = ensureBubble();
    box.children[0].textContent = link.dataset.giftTitle || '';
    box.children[1].textContent = link.dataset.giftVariant || '';
    box.children[2].textContent = link.dataset.giftRrp ? 'RRP: ' + link.dataset.giftRrp : '';
    box.hidden = false;
    const rect = link.getBoundingClientRect();
    position(x ?? rect.left + rect.width / 2, y ?? rect.top);
  }
  function hide() { if (bubble) bubble.hidden = true; active = null; }
  document.addEventListener('pointerover', e => { const a=linkOf(e.target); if (a && e.pointerType==='mouse') show(a,e.clientX,e.clientY); });
  document.addEventListener('pointerout', e => { const a=linkOf(e.target); if (a && e.pointerType==='mouse' && !a.contains(e.relatedTarget) && document.activeElement!==a) hide(); });
  document.addEventListener('focusin', e => { const a=linkOf(e.target); if(a) show(a); });
  document.addEventListener('focusout', e => { if(linkOf(e.target)) hide(); });
  document.addEventListener('pointerdown', e => {
    const a=linkOf(e.target); clearTimeout(timer); held=false;
    if (!a || e.pointerType==='mouse') return;
    startX=e.clientX; startY=e.clientY;
    timer=setTimeout(() => { held=true; show(a,startX,startY); },450);
  });
  document.addEventListener('pointermove', e => {
    if (e.pointerType==='mouse' && active && linkOf(e.target)===active) position(e.clientX,e.clientY);
    else if (Math.abs(e.clientX-startX)>10 || Math.abs(e.clientY-startY)>10) clearTimeout(timer);
  });
  document.addEventListener('pointerup', () => clearTimeout(timer));
  document.addEventListener('pointercancel', () => {clearTimeout(timer); held=false;});
  document.addEventListener('click', e => {
    if (held && linkOf(e.target)) {e.preventDefault(); held=false;}
    else if (!linkOf(e.target)) hide();
  },true);
  document.addEventListener('contextmenu', e => {if(held && linkOf(e.target)) e.preventDefault();});
  document.addEventListener('keydown', e => {if(e.key==='Escape') hide();});
  document.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);
})();